module.exports = __webpack_public_path__ + "img/confirm.696adf78.svg";